const images = [
  "https://images.pexels.com/photos/3807277/pexels-photo-3807277.jpeg",
  "https://images.unsplash.com/photo-1659576048262-940d9c1c84fe",
];

export const Team = ({ t }) => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative bg-zinc-900/40 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="overline">{t.team.overline}</span>
          <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
            {t.team.title}
          </h2>
          <p className="font-body mt-6 text-zinc-400 text-base md:text-lg max-w-2xl leading-relaxed">
            {t.team.subtitle}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {t.team.members.map((m, i) => (
            <article
              key={m.name}
              data-testid={`team-card-${i}`}
              className="group bg-zinc-950 border border-zinc-800 hover:border-red-600/40 transition-colors overflow-hidden"
            >
              <div className="overflow-hidden h-80 md:h-96">
                <img
                  src={images[i]}
                  alt={m.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="p-8 md:p-10">
                <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase text-red-600">
                  {m.role}
                </span>
                <h3 className="font-heading mt-3 text-3xl md:text-4xl font-bold tracking-tighter text-zinc-50">
                  {m.name}
                </h3>
                <p className="font-body mt-4 text-zinc-400 leading-relaxed">
                  {m.bio}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
